import { initialFeedbackItems } from "@/components/FeedbackModal";

import { useLocalStorage } from "./storage";

export function useProspectVerificationId() {
  return useLocalStorage("feedback", initialFeedbackItems);
}
